<template>

    <div class="tableAction">
        <!-- right -->
        
        <div class="filtersBtnsContainer" id="rightFilters"
        >
            <div class="filterWrap">
                <button
                    @mouseleave="$parent.filter_hovered = false"
                    @mouseover="$parent.filter_hovered = true"
                    :class="[
                        $parent.showFilterOptions &&
                        !($store.state.deals.length < $store.state.total)
                            ? 'btn big hollowClean filterBtn active'
                            : '',
                        'btn big hollowClean filterBtn ',
                    ]"
                    @click="$parent.toggleShowFilter"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        class="icon"
                    >
                        <g fill="none" fill-rule="evenodd">
                            <g>
                                <g>
                                    <path
                                        d="M0 0H24V24H0z"
                                        transform="translate(-1244 -1133) translate(1244 1133)"
                                    ></path>
                                    <g class="f1" fill="#00244E">
                                        <path
                                            d="M4 4h2V2H4v2zm3.8-2C7.4.8 6.3 0 5 0 3.7 0 2.6.8 2.2 2H0v2h2.2C2.6 5.2 3.7 6 5 6c1.3 0 2.4-.8 2.8-2H18V2H7.8zM13 10h2V8h-2v2zm1-4c-1.3 0-2.4.8-2.8 2H0v2h11.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H18V8h-1.2c-.4-1.2-1.5-2-2.8-2zM7 16h2v-2H7v2zm1-4c-1.3 0-2.4.8-2.8 2H0v2h5.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H18v-2h-7.2c-.4-1.2-1.5-2-2.8-2z"
                                            transform="translate(-1244 -1133) translate(1244 1133) translate(3 3)"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span class="text"> סינון</span>
                </button>

                <div
                    v-if="
                        $parent.showFilterOptions
                    "
                    class="customDropdown show"
                    style="height: 160px"
                >
                    <div
                        style="
                            display: grid;
                            grid-template-columns: 90% 10%;
                            cursor: pointer;
                        "
                        @click="$parent.showDealTypes = !$parent.showDealTypes"
                    >
                        <div>
                            <button style="margin-right: -20px" class="btn">
                                {{ $parent.selectedDealType }}
                            </button>
                        </div>
                        <div style="display: flex; align-items: center">
                            <button v-if="!$parent.showDealTypes" class="arrow up"></button>
                            <button v-else class="arrow"></button>
                        </div>
                        <input
                            id="react-select-5-input"
                            readonly=""
                            tabindex="0"
                            aria-autocomplete="list"
                            class="css-62g3xt-dummyInput"
                            value=""
                        />
                        <div class="customDropdown show" v-show="$parent.showDealTypes">
                            <li
                                v-for="(option, index) in $parent.dealTypeOptions"
                                :key="index"
                                class="dropdownItem"
                                @click="$parent.filterDealType(option.value, option.text)"
                            >
                                <button
                                    type="button"
                                    :class="{
                                        current: option.value === $parent.selectedDealType,
                                    }"
                                    class="dropdownBtn"
                                >
                                    {{ option.text }}
                                </button>
                            </li>
                        </div>
                    </div>

                    <div
                        style="
                            display: grid;
                            grid-template-columns: 90% 10%;
                            cursor: pointer;
                        "
                        @click="$parent.showAssetTypes = !$parent.showAssetTypes"
                    >
                        <div>
                            <button style="margin-right: -20px" class="btn">
                                {{ $parent.selectedAssetType }}
                            </button>
                        </div>
                        <div style="display: flex; align-items: center">
                            <button v-if="!$parent.showAssetTypes" class="arrow up"></button>
                            <button v-else class="arrow"></button>
                        </div>
                        <input
                            id="react-select-6-input"
                            readonly=""
                            tabindex="0"
                            aria-autocomplete="list"
                            value=""
                        />
                        <div
                            style="margin-top: 36px; height: 205px"
                            class="customDropdown show"
                            v-show="$parent.showAssetTypes"
                        >
                            <li
                                v-for="(option, index) in $parent.assetTypeOptions"
                                :key="index"
                                class="dropdownItem"
                                @click="$parent.filterAssetType(option.value, option.text)"
                            >
                                <button type="button" class="dropdownBtn">
                                    {{ option.text }}
                                </button>
                            </li>
                        </div>
                    </div>

                    <div
                        style="
                            display: grid;
                            grid-template-columns: 90% 10%;
                            cursor: pointer;
                        "
                        @click="$parent.showDealsPeriods = !$parent.showDealsPeriods"
                    >
                        <div>
                            <button style="margin-right: -20px" class="btn">
                                {{ $parent.selectedDealsPeriod }}
                            </button>
                        </div>
                        <div style="display: flex; align-items: center">
                            <button v-if="!$parent.showDealsPeriods" class="arrow up"></button>
                            <button v-else class="arrow"></button>
                        </div>
                        <input
                            id="react-select-6-input"
                            readonly=""
                            tabindex="0"
                            aria-autocomplete="list"
                            value=""
                        />
                        <div
                            style="margin-top: 82px; height: 205px"
                            class="customDropdown show"
                            v-show="$parent.showDealsPeriods"
                        >
                            <li
                                v-for="(option, index) in $parent.dealsPeriodOptions"
                                :key="index"
                                class="dropdownItem"
                                @click="$parent.filterDealsPeriods(option.value, option.text)"
                            >
                                <button type="button" class="dropdownBtn">
                                    {{ option.text }}
                                </button>
                            </li>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="filterWrap">
                <button
                    @mouseleave="$parent.sort_hovered = false"
                    @mouseover="$parent.sort_hovered = true"
                    @click="$parent.toggleShowSort()"
                    :class="[
                        $parent.showSort &&
                        !($store.state.deals.length < $store.state.total)
                            ? 'btn big hollowClean filterBtn active'
                            : '',
                        'btn big hollowClean filterBtn',
                    ]"
                >
                    <svg
                        version="1.0"
                        id="Layer_1"
                        width="24px"
                        height="24px"
                        x="0px"
                        y="0px"
                        viewBox="0 0 24 24"
                        class="icon"
                    >
                        <line
                            class="st0"
                            x1="5.2"
                            y1="6.7"
                            x2="5.2"
                            y2="18.7"
                            style="
                                fill: none;
                                stroke-width: 2;
                                stroke-linecap: round;
                                stroke-miterlimit: 10;
                            "
                        ></line>
                        <polyline
                            class="st1"
                            points="2.2,15.7 5.2,18.7 8.2,15.7 "
                            style="
                                fill: none;
                                stroke-width: 2;
                                stroke-miterlimit: 10;
                            "
                        ></polyline>
                        <line
                            class="st1"
                            x1="10.5"
                            y1="6.7"
                            x2="22.5"
                            y2="6.7"
                            style="
                                fill: none;
                                stroke-width: 2;
                                stroke-miterlimit: 10;
                            "
                        ></line>
                        <line
                            class="st1"
                            x1="10.5"
                            y1="10.7"
                            x2="19.5"
                            y2="10.7"
                            style="
                                fill: none;
                                stroke-width: 2;
                                stroke-miterlimit: 10;
                            "
                        ></line>
                        <line
                            class="st1"
                            x1="10.5"
                            y1="14.7"
                            x2="16.5"
                            y2="14.7"
                            style="
                                fill: none;
                                stroke-width: 2;
                                stroke-miterlimit: 10;
                            "
                        ></line>
                        <line
                            class="st1"
                            x1="10.5"
                            y1="18.7"
                            x2="13.5"
                            y2="18.7"
                            style="
                                fill: none;
                                stroke-width: 2;
                                stroke-miterlimit: 10;
                            "
                        ></line>
                    </svg>
                    <span class="text"> מיון</span>
                </button>
                <div
                    :class="[
                        $parent.showSort ? 'customDropdown sort show' : '',
                        'customDropdown sort ',
                    ]"
                >
                    <ul class="dropdownList">
                        <li
                            v-for="(option, index) in $parent.sortOptions"
                            :key="index"
                            class="dropdownItem"
                            @click="$parent.tableSort(option.value)"
                        >
                            <button
                                type="button"
                                :class="{
                                    current: option.value === $parent.selectedSortOption,
                                }"
                                class="dropdownBtn"
                            >
                                {{ option.text }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- center -->
        <div class="roomSelectWrapper">
            <button
                @click="$parent.showRoomsMenu = !$parent.showRoomsMenu"
                class="roomsBtn btn big hollow"
            >
                {{ $parent.roomsDisplay }}
                <span v-if="$parent.showRoomsMenu" class="arrow"> </span>
                <span v-else class="arrow up"> </span>
            </button>

            <div
                :class="[
                    $parent.showRoomsMenu ? 'searchCollapseContainer rooms open' : '',
                    'searchCollapseContainer rooms',
                ]"
                aria-hidden="false"
            >
                <div class="inner">
                    <div class="roomsWrap">
                        <button
                            v-for="(option, index) in $parent.roomOptions"
                            :key="index"
                            :class="[
                                $parent.selectedRooms.includes(option.value)
                                    ? 'whomBtn active'
                                    : '',
                                'whomBtn',
                            ]"
                            type="button"
                            @click="$parent.toggleRoom(option.value)"
                        >
                            <img :src="option.image" :alt="option.text" />
                            <p class="text">{{ option.text }}</p>
                        </button>
                    </div>
                    <!--                                      <button class="btn blue updateBtn">עדכון</button> -->
                </div>
            </div>
        </div>
        <!-- left -->
        <div class="filtersBtnsContainer" >
            <div class="filterWrap"  style="width:100%;">

                <div  v-if="($route.query.view == 'neighborhood' || $route.query.view == 'settlement') && $store.state.polygonIds.length == 0" id="leftFilters">
                    <input class="btn big hollowClean filterBtn " 
                    id="street_search"
                    v-model="$parent.street_search"  
                    @input="$parent.filterList"
                    @click="$parent.showAllItems"
                    :placeholder="$parent.street_search_placeholder"
                    @keydown="$parent.handleKeyDown"
                    style="width:100%;"
                    />
                    <div v-if="$parent.showSuggestions == true"
                        class="customDropdown show streetDrop" style="width:100%;height: fit-content; max-height: 400px; overflow: scroll;overflow-x: hidden;">
                        <li v-for="(street, index) in $parent.filteredStreets" :key="index" 
                            class="dropdownItem">
                            <button type="button" class="dropdownBtn" @click="$parent.filterDealsStreets(street)"
                            role="option"
                            :id="'react-autowhatever-1--item-' + index" 
                            :aria-selected="$parent.selectedIndex === index"
                            :class="['react-autosuggest__suggestion', {'react-autosuggest__suggestion--highlighted': $parent.selectedIndex === index}]"
                            :data-suggestion-index="index">
                            <div class="react-autosuggest__suggestion">
                                <span class="location">
                                    <span v-html="$parent.highlightText(street.title, $parent.street_search)"></span>
                                </span>
                            </div>

                            </button>

                        </li>
                    </div>
                    <button @click="$parent.cancelStreetsFilter"
                    aria-label="בטל סינון" class="deleteTextIcon show"><img src="/images/autosuggestCloseIcon.png"  class="icon"></button>
                </div>
                

            </div>
        </div>
    </div>

</template>

<script>

export default {
  name: 'TableAction',
}


</script>


<style scoped>

.tableAction {
	display: flex;
	justify-content: space-between;
  }
  
  .filtersBtnsContainer {
	flex: 1; /* This will take the remaining width */

  }
  
  #rightFilters {
	flex: 0 0 auto; /* This will allow it to take its width */
	width: auto; /* Or set a specific width */
  }

#leftFilters {
	margin-right: 12px;
}

@media screen and (min-width: 1024px) {

	.filtersBtnsContainer{
		max-width: 250px;
	}
  }
  



.streetDrop {
	max-height: 300px;
	overflow-x: auto; /* Horizontal scroll */
	overflow-y: hidden; /* Prevent vertical scrolling */
	background-color: #ffffff;
  }
 
  .streetDrop::-webkit-scrollbar {
	border-radius: 5px;
	width: 5px;
	background-color: transparent;
	height: 4px; /* Height of the scrollbar */
  }
  
  
  .streetDrop::-webkit-scrollbar-track {
	background:transparent; /* Color of the tracking area */
	border-radius: 15px;

  }
  
  .streetDrop::-webkit-scrollbar-thumb {
	background-color: #888; /* Scrollbar thumb color */
	border-radius: 45px; /* Rounded corners */
	border: 4px solid #484545; /* Padding around the thumb */
	height: 100px;
  }
  
  /* Change thumb color when hovered */
  .streetDrop::-webkit-scrollbar-thumb:hover {
	background: #555;
	border-radius: 15px;
  }
   
button:disabled {
	cursor: wait;
}
.scrollmenu-container {
	/* ... other styles ... */

	/* Add transition for smooth scroll animation */
	transition: scroll-left 0.3s ease-in-out;
}
.grid-container {
	display: grid;
	grid-template-columns: 10% 80% 10%; /* Three columns: 10%, 80%, 10% */
	align-items: center; /* Optional: Centers items vertically within the grid container */
	/* ... other styles ... */
}

div.scrollmenu {
	display: block;
	overflow: auto;
	white-space: nowrap;
	z-index: -1;
	margin-top: 120px;
}

div.scrollmenu a {
	display: inline-block;
	color: white;
	text-align: center;
	padding: 14px;
	text-decoration: none;
	z-index: -1;
	color: black;
}

div.scrollmenu a:hover {
	background-color: tr;
	z-index: -1;
}

.details-row {
	display: none;
}
.fade-enter-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.filter_circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid blue;
	border-top: 2px solid transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(0deg);
	animation: spin 2s linear infinite;
}

.sort_circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid blue;
	border-top: 2px solid transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(0deg);
	animation: spin 2s linear infinite;
}

.filter_rooms_circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid blue;
	border-top: 2px solid transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(0deg);
	animation: spin 2s linear infinite;
}

@keyframes spin {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
	}
	100% {
		transform: translate(-50%, -50%) rotate(360deg);
	}
}

#wrapper {
	position: relative;
	/*background:#333;*/
	height: 100%;
}

.profile-main-loader {
	position: fixed !important;
	left: 50%;
	right: 50%;
	top: 50%;
	bottom: 50%;
	width: 300px;
	height: 300px; /* assuming you want it square */
	margin-left: -100px; /* half of the width */
	margin-top: -100px; /* half of the height */
	z-index: 900 !important;
}

.profile-main-loader .loader {
	position: relative;
	margin: 0px auto;
	width: 150px;
	height: 150px;
}
.profile-main-loader .loader:before {
	content: "";
	display: block;
	padding-top: 100%;
}

.circular-loader {
	-webkit-animation: rotate 2s linear infinite;
	animation: rotate 2s linear infinite;
	height: 100%;
	-webkit-transform-origin: center center;
	-ms-transform-origin: center center;
	transform-origin: center center;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	margin: auto;
}



.trendsArrow {
    width: 2px;
    height: 12px;
    position: absolute;
    right: 10px;
    background: green;
}


.suggestions-list {
	list-style-type: none;
	padding: 0;
	margin-top: 8px;
	border: 1px solid #ccc;
	background-color: #fff;
	max-height: 200px;
	overflow-y: auto;
  }
  
  .suggestions-list li {
	padding: 8px;
	cursor: pointer;
  }
  
  .suggestions-list li:hover {
	background-color: #f0f0f0;
  }
  </style>